export function getDigits(idString) {
  return idString.replace(/\D/g, '') //Keep only digits
}

export function formatMatricule(matriculeDigits) {
  matriculeDigits += "_____________"
  matriculeDigits = matriculeDigits.slice(0,13)
  matriculeDigits = matriculeDigits.slice(0, 8) + ' ' + matriculeDigits.slice(8)
  matriculeDigits = matriculeDigits.slice(0, 6) + ' ' + matriculeDigits.slice(6)
  matriculeDigits = matriculeDigits.slice(0, 4) + ' ' + matriculeDigits.slice(4)
  return matriculeDigits
}

export function getFormattedCnsPrefixForPwr(pwr) {
  const birthdate = pwr.birthDate
  if (!birthdate) {console.log("Error. No birthday for this pwr."); return;}
  return birthdate.slice(0,10).replaceAll("-", " ")
//   matriculeDigits = matriculeDigits.slice(0,8)
//   matriculeDigits = matriculeDigits.slice(0, 8) + ' ' + matriculeDigits.slice(8)
//   matriculeDigits = matriculeDigits.slice(0, 6) + ' ' + matriculeDigits.slice(6)
//   matriculeDigits = matriculeDigits.slice(0, 4) + ' ' + matriculeDigits.slice(4)
//   return matriculeDigits
}

/**
 * Validate the last two check digits of a Luxembourg matricule (CNS).
 *
 * A 13-digit matricule has the form:
 *   [ 11 base digits ][ Luhn ][ Verhoeff ]
 *
 * Where:
 *   - digit 12 is the Luhn check digit of the first 11 digits
 *   - digit 13 is the Verhoeff check digit of the first 11 digits
 * Example usage:
 *     isValidMatriculeChecksum("1990010112345");          // false (random digits)
 *     isValidMatriculeChecksum("1990 0101 123 45");       // false (spaces stripped, then checked)
 *
 * @param {string} input - matricule string; non-digit chars are stripped first
 * @returns {boolean} true iff input is 13 digits AND last 2 match the checksums
 */
export function isValidMatriculeChecksum(input) {
  if (input == null) return false;

  // Strip everything that isn't a digit
  const digits = String(input).replaceAll("\\D", "");

  // Only 13-digit matricules carry both check digits
  if (digits.length !== 13) return false;

  const base = digits.slice(0, 11);
  const expectedLuhn     = luhnDigit(base);
  const expectedVerhoeff = verhoeffDigit(base);
  const inputLuhn        = Number(digits[11]);
  const inputVerhoeff    = Number(digits[12]);

  return (
    inputLuhn === expectedLuhn &&
    inputVerhoeff === expectedVerhoeff
  );
}

/**
 * Luhn check digit (right-to-left, even positions weighted x2).
 */
function luhnDigit(n) {
  let total = 0;
  for (let pos = 0; pos < n.length; pos++) {
    const weight = pos % 2 === 0 ? 2 : 1;
    let d = parseInt(n[n.length - pos - 1], 10) * weight;
    if (d > 9) d -= 9;
    total += d;
  }
  return (10 - (total % 10)) % 10;
}

/**
 * Verhoeff check digit using the standard Dihedral-group tables.
 */
function verhoeffDigit(n) {
  const D = [
    [0,1,2,3,4,5,6,7,8,9], [1,2,3,4,0,6,7,8,9,5],
    [2,3,4,0,1,7,8,9,5,6], [3,4,0,1,2,8,9,5,6,7],
    [4,0,1,2,3,9,5,6,7,8], [5,9,8,7,6,0,4,3,2,1],
    [6,5,9,8,7,1,0,4,3,2], [7,6,5,9,8,2,1,0,4,3],
    [8,7,6,5,9,3,2,1,0,4], [9,8,7,6,5,4,3,2,1,0],
  ];
  const P = [
    [0,1,2,3,4,5,6,7,8,9], [1,5,7,6,2,8,3,0,9,4],
    [5,8,0,3,7,9,6,1,4,2], [8,9,1,6,0,4,3,5,2,7],
    [9,4,5,3,1,2,6,8,7,0], [4,2,8,6,5,7,3,9,0,1],
    [2,7,9,3,8,0,6,4,1,5], [7,0,4,6,9,1,3,2,5,8],
  ];
  const INV = [0,4,3,2,1,5,6,7,8,9];

  let c = 0;
  for (let pos = 0; pos < n.length; pos++) {
    c = D[c][P[(pos + 1) % 8][parseInt(n[n.length - pos - 1], 10)]];
  }
  return INV[c];
}

